import React from 'react';
import {createRoot} from 'react-dom/client';
import {I18nextProvider} from 'react-i18next';
import i18n from './i18n'
import 'bootstrap';
import './scss/custom.scss';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Root from "./Root";
import Article, {loader as articleLoader} from "./Article";
import Error from "./Error";
import ArticleIntroList, {loader as articleIntroListLoader} from "./ArticleIntroList";
import Page, {loader as pageLoader} from "./Page";
import AuthCallback from "./AuthCallback";
import {AuthProvider} from "./service/AuthProvider";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

const router = createBrowserRouter([
    {
        path: "/",
        element: <Root/>,
        errorElement: <Error/>,
        children: [
            {
                path: "/",
                element: <ArticleIntroList/>,
                loader: articleIntroListLoader,
            },
            {
                path: ":page",
                element: <ArticleIntroList/>,
                loader: articleIntroListLoader,
            },
            {
                path: "article/:articleId",
                element: <Article/>,
                loader: articleLoader
            },
            {
                path: "page/:pageId",
                element: <Page/>,
                loader: pageLoader
            },
            {
                path: "auth/callback",
                element: <AuthCallback/>,
            },
        ],
    },
]);

const queryClient = new QueryClient();

const container = document.getElementById('root')
const root = createRoot(container!);
root.render(
    <I18nextProvider i18n={i18n}>
        <React.StrictMode>
            <AuthProvider>
                <QueryClientProvider client={queryClient}>
                    <RouterProvider router={router}/>
                </QueryClientProvider>
            </AuthProvider>
        </React.StrictMode>
    </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
